module.exports = __webpack_public_path__ + "img/somiah.228fb502.webp";